export const WIDGET_AUTH_INTEGRATION_STORAGE_KEY = 'feel_widget_auth_integration_id';
export const WIDGET_AUTH_INTEGRATION_QUERY_KEY = 'wi';
export const WIDGET_AUTH_RETURN_URL_STORAGE_KEY = 'feel_widget_auth_return_url';
export const WIDGET_AUTH_RETURN_URL_QUERY_KEY = 'wr';
export const WIDGET_AUTH_USER_HINT_KEY = 'widgetAuthUserHint';
/** JSON: { integrationId, logoUrl, brandName, primaryColor } — aplicado no painel antes do fetch da integração */
export const WIDGET_AUTH_BRANDING_SNAPSHOT_KEY = 'feel_widget_auth_branding_snapshot';
/** Hex sem # — mantém o MUI primary entre navegações / re-renders */
export const FEEL_THEME_PRIMARY_STORAGE_KEY = 'feel_theme_primary_hex';

export function readFeelThemePrimaryFromSession() {
  try {
    const v = sessionStorage.getItem(FEEL_THEME_PRIMARY_STORAGE_KEY);
    return v && String(v).trim()
      ? String(v)
          .trim()
          .replace(/^#/, '')
      : null;
  } catch (_) {
    return null;
  }
}

export function writeFeelThemePrimaryToSession(hexNoHash) {
  try {
    if (hexNoHash && String(hexNoHash).trim()) {
      sessionStorage.setItem(
        FEEL_THEME_PRIMARY_STORAGE_KEY,
        String(hexNoHash)
          .replace(/^#/, '')
          .trim()
      );
    }
  } catch (_) {
    /* ignore */
  }
}

export function clearFeelThemePrimaryFromSession() {
  try {
    sessionStorage.removeItem(FEEL_THEME_PRIMARY_STORAGE_KEY);
  } catch (_) {
    /* ignore */
  }
}

export function normalizeWidgetIntegrationAccent(c) {
  if (c == null || (typeof c === 'string' && !String(c).trim())) {
    return null;
  }
  const v = String(c).trim();
  return v.startsWith('#') ? v : `#${v}`;
}

/** Converte o snapshot persistido no formato do painel (FeelPanelBrandingContext). */
export function panelBrandingFromWidgetSnapshot(snap) {
  if (!snap) {
    return null;
  }
  const accentColor = normalizeWidgetIntegrationAccent(snap.primaryColor);
  const logoUrl = snap.logoUrl || null;
  const brandName = snap.brandName || '';
  if (!logoUrl && !brandName && !accentColor) {
    return null;
  }
  return { logoUrl, brandName, accentColor };
}

/** Lê storage após redirect do widget — usado no estado inicial do provider e após gravar o snapshot. */
export function readWidgetAuthBrandingFromSession() {
  try {
    const id = sessionStorage.getItem(WIDGET_AUTH_INTEGRATION_STORAGE_KEY);
    const raw = sessionStorage.getItem(WIDGET_AUTH_BRANDING_SNAPSHOT_KEY);
    if (!id || !raw) {
      return null;
    }
    const snap = JSON.parse(raw);
    if (!snap || String(snap.integrationId) !== id) {
      return null;
    }
    return panelBrandingFromWidgetSnapshot(snap);
  } catch (_) {
    return null;
  }
}

export function clearWidgetAuthIntegrationContext() {
  try {
    sessionStorage.removeItem(WIDGET_AUTH_INTEGRATION_STORAGE_KEY);
    sessionStorage.removeItem(WIDGET_AUTH_BRANDING_SNAPSHOT_KEY);
    sessionStorage.removeItem(FEEL_THEME_PRIMARY_STORAGE_KEY);
    sessionStorage.removeItem(WIDGET_AUTH_RETURN_URL_STORAGE_KEY);
  } catch (_) {
    /* ignore */
  }
}

export function writeWidgetAuthReturnUrlToSession(url) {
  try {
    if (!url || !String(url).trim()) {
      sessionStorage.removeItem(WIDGET_AUTH_RETURN_URL_STORAGE_KEY);
      return;
    }
    const parsed = new URL(String(url).trim());
    if (!/^https?:$/i.test(parsed.protocol)) {
      return;
    }
    sessionStorage.setItem(WIDGET_AUTH_RETURN_URL_STORAGE_KEY, parsed.toString());
  } catch (_) {
    /* ignore invalid urls/storage errors */
  }
}

export function readWidgetAuthReturnUrlFromSession() {
  try {
    const raw = sessionStorage.getItem(WIDGET_AUTH_RETURN_URL_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = new URL(raw);
    if (!/^https?:$/i.test(parsed.protocol)) {
      return null;
    }
    return parsed.toString();
  } catch (_) {
    return null;
  }
}

export function clearWidgetAuthUserHintFromStorage() {
  try {
    localStorage.removeItem(WIDGET_AUTH_USER_HINT_KEY);
  } catch (_) {
    /* ignore */
  }
}
